
<app-movimento-financeiro-resumo></app-movimento-financeiro-resumo>

<app-indicadores-do-dia></app-indicadores-do-dia>
<app-indicadores-do-mes></app-indicadores-do-mes>

<app-despesas-mensal></app-despesas-mensal>
<app-produtos-mais-vendidos-chart></app-produtos-mais-vendidos-chart>
<app-top-clientes-chart></app-top-clientes-chart>
<app-venda-pedras-por-mes-chart></app-venda-pedras-por-mes-chart>
<app-orcamentos-por-dia-semana-chart></app-orcamentos-por-dia-semana-chart>
<app-vendas-por-dia-semana-chart></app-vendas-por-dia-semana-chart>
